export class ResetPasswordDto{
    oldPassword: string;
    password: string;
    passwordConfirm: string;
    constructor(){
        this.oldPassword = "";
        this.password = "";
        this.passwordConfirm = "";
    }
}